module.exports = __webpack_public_path__ + "img/difficultyLevel_3.590cae46.svg";